import React from 'react';
import OnboardingForm from '../components/OnboardingForm';

const OnboardingPage: React.FC = () => {
  return <OnboardingForm />;
};

export default OnboardingPage; 